import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useCallback } from 'react'
import { defineMessages, useIntl } from 'react-intl'

interface Props {
  /** Proceeds to the next cancel step. The "Keep membership" primary always dismisses the modal. */
  onContinueToCancel: () => void
}

// Exported so other cancel-flow screens (e.g. the cancellation survey) reuse the exact same
// "Keep membership" copy instead of redefining it.
export const retentionFooterMessages = defineMessages({
  keepMembership: {
    id: 'BuJHpg4MmbCPQH4xmGYV',
    defaultMessage: 'Keep membership',
    description: 'Primary button to keep the membership on a cancel-retention screen',
  },
  continueToCancel: {
    id: '1sOs6RQo-S_Lxl7kHeuy',
    defaultMessage: 'Continue to cancel',
    description: 'Secondary button to proceed with cancelling on a cancel-retention screen',
  },
})

/**
 * Shared footer for the LuxPlus+ cancel-retention screens (keep-benefits, keep-price,
 * renewal-bonus): a LuxPlus-blue "Keep membership" primary that dismisses the modal and a
 * "Continue to cancel" secondary that advances the flow.
 */
function LuxPlusRetentionModalFooter({ onContinueToCancel }: Props) {
  const intl = useIntl()
  const modalElement = useModalElementContext()
  const dismissModal = useCallback(() => {
    modalElement.resolve()
  }, [modalElement])

  return <ProductPaletteProvider palette="lux-plus">
    <ModalFooter
      // Stack on mobile ("Keep membership" above "Continue to cancel"); side-by-side on tablet+.
      actionsLayout="stacked"
      tabletActionsLayout="auto"
      primaryActionProps={{ children: intl.formatMessage(retentionFooterMessages.keepMembership), onClick: dismissModal }}
      secondaryActionProps={{ children: intl.formatMessage(retentionFooterMessages.continueToCancel), onClick: onContinueToCancel }}
    />
  </ProductPaletteProvider>
}

export default LuxPlusRetentionModalFooter
